import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=b7b8a610&"
import script from "./ChatPage.vue?vue&type=script&lang=ts&"
export * from "./ChatPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports